

// nav menu desktop
const prevNav = document.querySelector('.prev-nav') as HTMLDivElement | null;
const header = document.querySelector('header') as HTMLDivElement | null;

if (header || prevNav) {
	window.addEventListener('scroll', () => {
		if (prevNav) {
			window.scrollY > 100 ? prevNav.classList.add('d-none') : prevNav.classList.remove('d-none');
		}
		if (header) {
			window.scrollY > 100 ? header.classList.add('bg-gray') : header.classList.remove('bg-gray');
		}
	});
}

const navbarToggler = document.querySelector('.navbar-toggler') as HTMLButtonElement | null;
const navbar = document.querySelector('.navbar') as HTMLButtonElement | null;
const body = document.querySelector('body') as HTMLBodyElement;

if (navbarToggler && navbar) {
	navbarToggler.addEventListener('click', () => {
		navbarToggler.getAttribute('aria-expanded') === 'true' ? body.classList.add('overflow-hidden') : body.classList.remove('overflow-hidden');
		navbarToggler.getAttribute('aria-expanded') === 'true' ? navbar.classList.add('mobile-nav-show') : navbar.classList.remove('mobile-nav-show');
	});
}

const dropdownLinks= document.querySelectorAll('header .dropdown .dropdown-toggle-desktop') as NodeListOf<HTMLDivElement>;
const navLinks= document.querySelectorAll('header .nav-item .nav-link') as NodeListOf<HTMLDivElement>;

function hoverDesktopDropdownLinks () {
	navLinks.forEach((navLink) => {
		navLink.addEventListener('mouseover', onNavLinkMouseOver);
	});

	dropdownLinks.forEach((dropdownLink) => {
		dropdownLink.addEventListener('mouseover', onDropdownLinkMouseOver);
		dropdownLink.nextElementSibling?.addEventListener('mouseleave', onDropdownLinkMouseLeave);
	});
}

function onNavLinkMouseOver(this: HTMLElement) {
	const activeDropdownLink= document.querySelector('.dropdown .dropdown-toggle-desktop.show') as HTMLDivElement;
	activeDropdownLink?.classList.remove('show');
	activeDropdownLink?.setAttribute('aria-expanded','false');
	activeDropdownLink?.nextElementSibling?.classList.remove('show');
	activeDropdownLink?.nextElementSibling?.nextElementSibling?.classList.remove('show');

}

function onDropdownLinkMouseOver(this: HTMLElement) {
	const activeDropdownLink= document.querySelector('.dropdown .dropdown-toggle-desktop.show') as HTMLDivElement;
	activeDropdownLink?.classList.remove('show');
	activeDropdownLink?.setAttribute('aria-expanded','false');
	activeDropdownLink?.nextElementSibling?.classList.remove('show');
	this.classList.add('show');
	this.setAttribute('aria-expanded','true');
	this.nextElementSibling?.classList.add('show');
	this.nextElementSibling?.nextElementSibling?.classList.add('show');

}

function onDropdownLinkMouseLeave(this: HTMLElement) {
	this.classList.remove('show');
	this.setAttribute('aria-expanded','false');
	this.nextElementSibling?.classList.remove('show');
	this.nextElementSibling?.nextElementSibling?.classList.remove('show');
}

navbar?.addEventListener('mouseleave', () => {
	const activeDropdownLink= document.querySelector('.dropdown .dropdown-toggle-desktop.show') as HTMLDivElement;
	activeDropdownLink?.classList.remove('show');
	activeDropdownLink?.setAttribute('aria-expanded','false');
	activeDropdownLink?.nextElementSibling?.classList.remove('show');
	activeDropdownLink?.nextElementSibling?.nextElementSibling?.classList.remove('show');
});
const mobileToggler = document.querySelectorAll('.mobile-toggler') as NodeListOf<HTMLButtonElement>;
mobileToggler.forEach((mobileToggler) => {
	mobileToggler.addEventListener('click', () => {
		const activeDropdown = document.querySelector('.dropdown-box.active') as HTMLDivElement;
		activeDropdown?.classList.remove('active');
		mobileToggler.parentElement?.classList.toggle('active');
	});
});
if(window.innerWidth > 1200) {
	hoverDesktopDropdownLinks();
	body.classList.remove('overflow-hidden');
	navbar?.classList.remove('mobile-nav-show');
}

window.addEventListener('resize', () => {
	if(window.innerWidth < 1200) {
		navLinks.forEach((navLink) => {
			navLink.removeEventListener('mouseover', onNavLinkMouseOver);
		});

		dropdownLinks.forEach((dropdownLink) => {
			dropdownLink.removeEventListener('mouseover', onDropdownLinkMouseOver);
			dropdownLink.nextElementSibling?.removeEventListener('mouseleave', onDropdownLinkMouseLeave);
			dropdownLink.nextElementSibling?.nextElementSibling?.removeEventListener('mouseleave', onDropdownLinkMouseLeave);
		});
	}
	else {
		hoverDesktopDropdownLinks();
		body.classList.remove('overflow-hidden');
		navbar?.classList.remove('mobile-nav-show');
	}
});


function updateGridTemplateRows() {
	const grid = document.querySelector('.grid') as HTMLDivElement;
	const gridItems = document.querySelectorAll('.grid-item') as NodeListOf<HTMLDivElement>;
	let templateColumns = '';

	if(grid && gridItems) {
		let items = 0;

		// window.innerWidth < 992 ? items = Math.ceil(gridItems.length / 2) : gridItems.length;
		window.innerWidth < 576 ? items = Math.ceil(gridItems.length / 3) : gridItems.length
		
		for (let i = 0; i < items; i++) {
			templateColumns += '1fr ';
		}
		grid.style.setProperty('--grid-rows-count',templateColumns.trim());
	
	}
	
}
updateGridTemplateRows();

function scrollToContentAnchor() {
	const hash = window.location.hash;
	if (!hash.startsWith('#c')) {
		return;
	}

	const target = document.querySelector(hash);
	if (!target) {
		return;
	}

	window.requestAnimationFrame(() => {
		target.scrollIntoView({ block: 'start' });
	});
}

window.addEventListener('load', () => {
	updateGridTemplateRows();
	window.setTimeout(scrollToContentAnchor, 0);
});
window.addEventListener('hashchange', scrollToContentAnchor);

window.addEventListener('resize', () => {
	updateGridTemplateRows();
});

const search = document.querySelector('#search a') as HTMLDivElement | null;
search?.addEventListener('click', () => {
	search?.parentElement?.classList.toggle('show');
});




